<template>
	<div class="file_step">
		<div class="info_list">
			<div class="last_title">fields marked with a * are required</div>
			<div class="item">
				<input type="text" placeholder="*First name" v-model="child_first_name">
			</div>
			<div class="item">
				<input type="text" placeholder="*Last name" v-model="child_last_name">
			</div>
			<div class="select_list flex align-center" >
				<div class="select_item flex align-center" @click="gender = 1">
					<img v-if="gender == 1" class="select" src="../../assets/images/icon/select_active.png" alt="">
					<div class="select" v-else></div>
					<div>Male</div>
				</div>
				<div class="select_item flex align-center" @click="gender = 2">
					<img v-if="gender == 2" class="select" src="../../assets/images/icon/select_active.png" alt="">
					<div class="select" v-else></div>
					<div>Female</div>
				</div>
				<div class="select_item flex align-center" @click="gender = 0">
					<img v-if="gender == 0" class="select" src="../../assets/images/icon/select_active.png" alt="">
					<div class="select" v-else></div>
					<div>Prefer not to say</div>
				</div>
			</div>
			<div class="item select_item data_select">
				<el-date-picker
					  v-model="birthday"
					  type="date"
					  local="en"
					  value-format="yyyy-MM-dd"
					  placeholder="*Birthday">
				</el-date-picker>
				<div class="dateShow">{{birthday}}</div>
			</div>
			<div class="item">
				<input type="text" placeholder="Nursery/School Name" v-model="school_name">
			</div>
		</div>
		<div class="info_list">
			<div class="first_title">Address</div>
			<div class="select_list flex align-center">
				<div class="select_item flex align-center" @click="changeGuar(0)">
					<img v-if="guardian == 0" class="select" src="../../assets/images/icon/select_active.png" alt="">
					<div class="select" v-else></div>
					<div>Parent/guardian</div>
				</div>
				<div class="select_item flex align-center" @click="changeGuar(1)">
					<img v-if="guardian == 1" class="select" src="../../assets/images/icon/select_active.png" alt="">
					<div class="select" v-else></div>
					<div>Alternative</div>
				</div>
			</div>
			
			<div class="item">
				<input type="text" placeholder="*Address line 1" v-model="address_line_one">
			</div>
			<div class="item">
				<input type="text" placeholder="*Address line 2" v-model="address_line_two">
			</div>
			<div class="first_title">Emergency Contact 1</div>
			<div class="item">
				<input type="text" placeholder="*First name" v-model="contact_first_name_one">
			</div>
			<div class="item">
				<input type="text" placeholder="*Last name" v-model="contact_last_name_one">
			</div>
			<div class="item">
				<input type="text" placeholder="*Mobile" v-model="contact_mobile_one">
			</div>
			<div class="item">
				<input type="text" placeholder="*E-mail" v-model="contact_email_one">
			</div>
			<div class="item">
				<input type="text" placeholder="*Relationship to the child" v-model="relationship_child_one">
			</div>
			<div class="first_title">Emergency Contact 2</div>
			<div class="item">
				<input type="text" placeholder="*First name" v-model="contact_first_name_two">
			</div>
			<div class="item">
				<input type="text" placeholder="*Last name" v-model="contact_last_name_two">
			</div>
			<div class="item">
				<input type="text" placeholder="*Mobile" v-model="contact_mobile_two">
			</div>
			<div class="item">
				<input type="text" placeholder="*E-mail" v-model="contact_email_two">
			</div>
			<div class="item">
				<input type="text" placeholder="*Relationship to the child" v-model="relationship_child_two">
			</div>
			<!-- <div class="item select_item">
				<el-select v-model="is_school" placeholder="是否上学" :popper-append-to-body="false">
				    <el-option
				      v-for="item in isOptions"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value">
				    </el-option>
				  </el-select>
			</div> -->
			
		</div>
		<div class="info_list">
			<div class="first_title">Will someone other than yourself be picking up your child ?</div>
			<div class="select_list flex align-center">
				<div class="select_item flex align-center" @click="selectSannyStatus = 1">
					<img class="select" src="../../assets/images/icon/select_active.png" v-if="selectSannyStatus == 1" alt="">
					<div class="select" v-else></div>
					<div>Yes</div>
				</div>
				<div class="select_item flex align-center" @click="selectSannyStatus = 0">
					<img class="select" src="../../assets/images/icon/select_active.png" v-if="selectSannyStatus == 0" alt="">
					<div class="select" v-else></div>
					<div>No</div>
				</div>
			</div>
			<div v-if="selectSannyStatus">
				<div class="item">
					<input type="text" placeholder="*First name" v-model="nanny_first_name">
				</div>
				<div class="item">
					<input type="text" placeholder="*Last Name" v-model="nanny_last_name">
				</div>
				<div class="item">
					<input type="text" placeholder="*mobile" v-model="nanny_contact">
				</div>
				<div class="item">
					<input type="text" placeholder="relationship to the child" v-model="nanny_child_relationship">
				</div>
			</div>
			
		</div>
		<div class="info_list">
			<div class="first_title">Medical Information</div>
			<div class="item">
				<input type="text" placeholder="*Is there any medical information that we need to be aware of? " v-model="medical">
			</div>
		</div>
		<div class="info_list">
			<div class="first_title">Allergy :</div>
			<div class="item">
				<input type="text" placeholder="*Is there any Allergy information that we need to be aware of? " v-model="allergy">
			</div>
		</div>
		<!-- <div class="permission">
			<div class="title">*Internal Photo Permission</div>
			<div class="second_title">By selecting yes, you consent to Curiouser taking photos of your child to be used for internal training purposes only. </div>
			<div class="select_list flex align-center">
				<div class="item flex align-center" @click="photo_permission = 1">
					<img class="select" src="../../assets/images/icon/select_active.png" v-if="photo_permission == 1" alt="">
					<div class="select" v-else></div>
					<div>Yes please</div>
				</div>
				<div class="item flex align-center" @click="photo_permission = 0">
					<img class="select" src="../../assets/images/icon/select_active.png" v-if="photo_permission == 0" alt="">
					<div class="select" v-else></div>
					<div>No thank you</div>
				</div>
			</div>
		</div> -->
		<div class="permission">
			<div class="title">* Photo Permission</div>
			<div class="second_title">We love to take photos of our little ones at Curiouser! By selecting yes, you consent to us using photos of your child taken in class for marketing purposes on our website, print or social media</div>
			<div class="select_list flex align-center">
				<div class="item flex align-center" @click="photo_marketing_permission = 1">
					<img class="select" src="../../assets/images/icon/select_active.png" v-if="photo_marketing_permission == 1" alt="">
					<div class="select" v-else></div>
					<div>Yes please</div>
				</div>
				<div class="item flex align-center" @click="photo_marketing_permission = 0">
					<img class="select" src="../../assets/images/icon/select_active.png" v-if="photo_marketing_permission == 0" alt="">
					<div class="select" v-else></div>
					<div>No thank you</div>
				</div>
			</div>
		</div>
		
		<div class="next_btn" @click='toNext'>Next</div>
	</div>
</template>

<script>
	export default{
		
		data(){
			return{
				selectSannyStatus:0,
				child_first_name:'',
				child_last_name:'',
				gender:1,
				birthday:'2022-09-20',
				guardian:1,
				first_name:'',
				last_name:'',
				contact_first_name_one:'',
				contact_first_name_two:'',
				contact_last_name_one:'',
				contact_last_name_two:'',
				contact_email_one:'',
				contact_email_two:'',
				contact_mobile_one:'',
				contact_mobile_two:'',
				relationship_child_one:'',
				relationship_child_two:'',
				is_school:'',
				photo_permission:0,
				photo_marketing_permission:0,
				school_name:'',
				nanny_last_name:'',
				nanny_first_name:'',
				nanny_contact:'',
				nanny_child_relationship:'',
				address_line_one:'',
				address_line_two:'',
				allergy:'',
				medical:'',
				town:'',
				postCode:'',
				email:'',
				mobile:'',
				isOptions:[{
					label:'Yes',
					value:1
				},{
					label:'No',
					value:0
				}]
			}
		},
		
		methods:{
			changeGuar(index){
				this.guardian = index;
				if(index == 0){
					
					this.address_line_one = this.$store.state.userInfo.address_line_one;
					this.address_line_two = this.$store.state.userInfo.address_line_two;
				}else{
					
					this.address_line_one = '';
					this.address_line_two = '';
				}
			},
			changeDate(e){
				console.log(e)
				var date = new Date(e)
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var day = date.getDay();
				if(year < 10){
					year = '0'+ year
				}
				if(month < 10){
					month = '0'+ month
				}
				if(day < 10){
					day = '0'+ day
				}
				this.birthday = month + '/' + day + '/' + year
			},
			toNext(){
				var params = {
					child_first_name:this.child_first_name,
					child_last_name:this.child_last_name,
					gender:this.gender,
					birthday:this.birthday,
					guardian:this.guardian == 0 ? 'Parent/guardian' : 'Alternative',
					first_name:this.first_name,
					last_name:this.last_name,
					contact_first_name_two:this.contact_first_name_two,
					contact_first_name_one:this.contact_first_name_one,
					contact_last_name_two:this.contact_last_name_two,
					contact_last_name_one:this.contact_last_name_one,
					contact_email_one:this.contact_email_one,
					contact_email_two:this.contact_email_two,
					contact_mobile_one:this.contact_mobile_one,
					contact_mobile_two:this.contact_mobile_two,
					relationship_child_one:this.relationship_child_one,
					relationship_child_two:this.relationship_child_two,
					// photo_permission:this.photo_permission,
					photo_marketing_permission:this.photo_marketing_permission,
					school_name:this.school_name,
					nanny_first_name:this.nanny_first_name,
					nanny_last_name:this.nanny_last_name,
					nanny_contact:this.nanny_contact,
					address_line_one:this.address_line_one,
					address_line_two:this.address_line_two,
					allergy:this.allergy,
					medical:this.medical,
					nanny_child_relationship:this.nanny_child_relationship
				}
				// for(let item in params){
				// 	if(!params[item] && item != photo_permission && item != photo_marketing_permission){
				// 		this.$message('fields marked with a * are required')
				// 		return
				// 	}
				// }\
				if(!this.child_first_name){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.child_last_name){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				// if(!this.first_name){
				// 	this.$message({
				// 		showClose:true,
				// 		duration:0,
				// 		message:'fields marked with a * are required'
				// 	})
				// 	return
				// }
				// if(!this.last_name){
				// 	this.$message({
				// 		showClose:true,
				// 		duration:0,
				// 		message:'fields marked with a * are required'
				// 	})
				// 	return
				// }
				if(!this.contact_first_name_two){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.contact_first_name_one){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.contact_last_name_two){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.contact_last_name_one){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.contact_email_one){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.contact_email_two){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.contact_mobile_one){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.contact_mobile_two){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.relationship_child_one){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				
				// if(!this.school_name){
				// 	this.$message('fields marked with a * are required')
				// 	return
				// }
				if(!this.relationship_child_two){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.address_line_one){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.address_line_two){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.allergy){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				if(!this.medical){
					this.$message({
						showClose:true,
						duration:0,
						message:'fields marked with a * are required'
					})
					return
				}
				this.$api.post('user/createChild',params,res=>{
					if(res.code == 1){
						this.$message('Successful')
						this.$emit('toNext',{type:2})
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.file_step{
		.info_list{
			width: 800px;
			margin: 0 auto;
			margin-bottom: 40px;
			.first_title{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #282E30;
				margin-top: 30px;
			}
			.item{
				width: 100%;
				height: 80px;
				background: #F7F2EB;
				border: 1px solid #282E30;
				border-radius: 10px;
				margin-top: 30px;
				padding-left: 30px;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #999999;
				line-height: 80px;
				position: relative;
				input{
					width: 100%;
					height: 100%;
					line-height: 80px;
				}
				&.data_select{
					overflow: hidden;
				}
				&.select_item{
					padding-left: 0;
					position: relative;
					.dateShow{
						padding-left: 30px;
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;
						left: 0;
						z-index: -1;
						background: #F7F2EB;
						font-size: 20px;
						font-family: Source Han Sans CN;
						font-weight: 500;
						color: #999999;
						line-height: 80px;	
					}
					::v-deep .el-select{ 
						top: -3px;
						width: 100%;
						height: 100%;
					}
					::v-deep .el-select>.el-input{
						width: 100%;
						height: 100%;
					}
					::v-deep .el-input--suffix .el-input__inner{
						width: 100%;
						height: 100%;
						background: #F7F2EB!important;
					}
					::v-deep .el-input--prefix .el-input__inner{
						width: 100%;
						height: 100%;
						background: #F7F2EB!important;
					}
					::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner{
						width: 100%;
						height: 100%;
						top: -3px;
					}
					::v-deep .el-date-table td span{
						text-align: center;
					}
				}
			}
			.select_list{
				margin-top: 20px;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #282E30;
				.select_item{
					margin-right: 152px;
					cursor: pointer;
					flex-shrink: 0;
				}
				.select{
					width: 16px;
					height: 16px;
					border: 1px solid #282E30;
					border-radius: 50%;
					margin-right: 10px;
				}
			}
			.el-date-editor.el-input, .el-date-editor.el-input__inner{
				width: 100%;
			}
			.el-input--prefix .el-input__inner{
				background: none;
				border: none;
				padding: 0;
			}
			.el-inpu{
				right: 0;
			}
		}
		.permission{
			width: 800px;
			margin: 30px auto 0;
			.title{
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #282E30;
			}
			.second_title{
				font-size: 16px;
				font-family: Source Han Sans CN;
				color: #282E30;
				margin-top: 10px;
			}
			.select_list{
				margin-top: 20px;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #282E30;
				.item{
					margin-right: 30px;
					cursor: pointer;
				}
				.select{
					width: 16px;
					height: 16px;
					border: 1px solid #282E30;
					border-radius: 50%;
					margin-right: 10px;
				}
			}
		}
		.last_title{
			text-align: center;
			margin-top: 20px;
		}
		.next_btn{
			width: 182px;
			height: 57px;
			background: #5C707A;
			border-radius: 29px;
			line-height: 57px;
			text-align: center;
			margin: 58px auto;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #F7F2EB;
			cursor: pointer;
		}
	}
</style>